import React from "react";
import { Box, Text } from "grommet";

// A label-above-value pair placed into a named Grid area (see
// LoanDetailSection/FunderDetailSection) - a real CSS grid, not two
// independent flex rows, so columns stay pixel-aligned between the
// Reference/Name row and the Amount/Status/Record status row below it.
// Two separate flex rows don't: each row's "equal share" math also divides
// up that row's own gaps, and a 2-item row has one fewer gap eating into
// its available width than a 3-item row, so the per-unit width ends up
// very slightly different between rows even with matching grow ratios.
const DetailField = ({ label, value, ...rest }) => (
    <Box gap="2px" {...rest}>
        <Text size="small" color="dark-5">
            {label}
        </Text>
        <Text weight="bold">{value}</Text>
    </Box>
);

export { DetailField };
